const SLOT_CONFIG = [
  {
    name: "Video Primary (GoPro)",
    required: true,
    multi: true,
    icon: "🎥",
    accept: ["mp4", "mov", "mkv", "avi"],
    suggestPattern: /gopro|go[\s_-]?pro/i,
  },
  {
    name: "Video (Zoom)",
    required: false,
    icon: "📹",
    accept: ["mp4", "mov", "mkv", "avi"],
    suggestPattern: /zoom/i,
  },
  {
    name: "Student Audio",
    required: true,
    multi: true,
    icon: "🎙️",
    accept: null,
    suggestPattern: /student/i,
  },
  {
    name: "Expert Audio",
    required: true,
    multi: true,
    icon: "🎤",
    accept: null,
    suggestPattern: /expert/i,
  },
  {
    name: "Recipe",
    required: true,
    icon: "📄",
    accept: ["pdf", "txt", "jpg", "jpeg", "heic", "png", "docx", "doc"],
    suggestPattern: /recipe|\.pdf$/i,
  },
  {
    name: "Metadata JSON",
    required: false,
    icon: "📊",
    accept: null,
    suggestPattern: /metadata|\.json$/i,
  },
  {
    name: "Unlabeled",
    required: false,
    icon: "📎",
    accept: null,
    suggestPattern: null,
  },
];

const REQUIRED_SLOTS = SLOT_CONFIG.filter(s => s.required).map(s => s.name);
const ALL_SLOTS = SLOT_CONFIG.map(s => s.name);

// Master switch for the multi-part (part 1 / part 2 / …) upload UI. Keep OFF
// until TBD's artifact model accepts multiple artifacts of the same type per
// task; flipping this on is what activates the "Add part" controls. The data
// model and submit logic tolerate additionalParts whenever present, so this
// only gates whether creators can create them.
const MULTI_PART_ENABLED = true;

// A slot that can hold ordered parts (activeFile = part 1, additionalParts =
// parts 2..N). Only meaningful while MULTI_PART_ENABLED is true.
function isMultiSlot(slotName) {
  return !!SLOT_CONFIG.find(s => s.name === slotName)?.multi;
}

// Per-project display relabels. The slot KEY (Firestore, storage, and the
// server-side artifact mapping) is unchanged — only the label shown to users
// differs. e.g. the "Appliance data" project shows "Recipe" as "Appliance
// Manual" while still storing under slots["Recipe"] → TBD "instructions".
const SLOT_LABEL_OVERRIDES = {
  "Appliance data": { "Recipe": "Appliance Manual" },
};
function slotLabel(project, slotName) {
  return SLOT_LABEL_OVERRIDES[project]?.[slotName] || slotName;
}

function validateSlotFile(slotName, filename) {
  const config = SLOT_CONFIG.find(s => s.name === slotName);
  if (!config?.accept) return true;
  const ext = (filename.split(".").pop() || "").toLowerCase();
  return config.accept.includes(ext);
}

function slotAcceptStr(slotName) {
  const config = SLOT_CONFIG.find(s => s.name === slotName);
  return config?.accept ? config.accept.map(e => `.${e}`).join(",") : undefined;
}

function slotTypeError(slotName) {
  const config = SLOT_CONFIG.find(s => s.name === slotName);
  if (!config?.accept) return null;
  return `Only ${config.accept.map(e => `.${e}`).join(", ")} allowed for ${slotName}.`;
}

function slotIcon(slotName) {
  const config = SLOT_CONFIG.find(s => s.name === slotName);
  return config?.icon || "📁";
}

function suggestSlot(filename) {
  const f = filename.toLowerCase();
  for (const config of SLOT_CONFIG) {
    if (config.suggestPattern && config.suggestPattern.test(f)) return config.name;
  }
  return "Unlabeled";
}

export {
  SLOT_CONFIG,
  REQUIRED_SLOTS,
  ALL_SLOTS,
  MULTI_PART_ENABLED,
  isMultiSlot,
  slotLabel,
  validateSlotFile,
  slotAcceptStr,
  slotTypeError,
  slotIcon,
  suggestSlot,
};
